import { Component, OnInit } from "@angular/core";
import { VersioningService } from "../../../../routes/Pages/versioning/services/versioning.service";
import { StorageService } from "../../../../routes/services/storage.service";
import { SettingsService } from "../../../../core/settings/settings.service";
const screenfull = require("screenfull");

@Component({
  selector: "app-other-configuration",
  templateUrl: "./other-configuration.html",
  styleUrls: ["./other-configuration.scss", "../offsidebar.component.scss"]
})
export class OtherConfigurationOffsidebarComponent implements OnInit {
  constructor(
    public versionService: VersioningService,
    public storageService: StorageService,
    public settings: SettingsService
  ) {}
  newVersion: any;
  currentVersion: string | null = null;

  ngOnInit(): void {
    if (localStorage.getItem("version")) this.currentVersion = localStorage.getItem("version");
    this.getLastVersion();
  }
  refresh() {
    localStorage.setItem("version", this.newVersion);
    location.reload();
  }

  getLastVersion() {
    this.versionService.getLastVersion().subscribe((res) => {
      if (!res || !res.results || !res.results.length) return;
      this.newVersion = res.results[0].version;

      if (this.newVersion !== this.currentVersion) {
        this.refresh();
      }
    });
  }
  toggleFullScreen() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }

  changeModeTable() {
    const { mode_table } = this.storageService.localValue;
    const local = this.storageService.localValue;

    let obj = { ...local, mode_table: !mode_table };
    this.storageService.editPreferences(obj)?.subscribe((resp) => {
      this.storageService.localValue = obj;
    });
  }

  /**
   * Alterna la configuración de mantener equipos seleccionados al cerrar modales.
   */
  toggleKeepDevicesSelected() {
    const { keep_devices_selected } = this.storageService.localValue;
    const local = this.storageService.localValue;

    let obj = { ...local, keep_devices_selected: !keep_devices_selected };
    this.storageService.editPreferences(obj)?.subscribe((resp) => {
      this.storageService.localValue = obj;
    });
  }

  /**
   * Alterna "Mantener menu colapsado": el sidebar muestra solo iconos y sus
   * submenus se abren flotantes. Se guarda en las preferencias del usuario.
   */
  toggleCollapsedMenu() {
    const local = this.storageService.localValue;
    const obj = { ...local, isCollapsedText: !local.isCollapsedText };

    this.settings.toggleLayoutSetting("isCollapsedText");
    this.storageService.editPreferences(obj)?.subscribe(() => {
      this.storageService.localValue = obj;
    });
  }
}
